import { useLightbox } from "./Lightbox";

// A customer's own photo on their review card (the `photo` field in
// data/reviews.js). Only ever a photo that customer sent us of their own job.
// Tapping it opens the site lightbox at full size.
export default function ReviewPhoto({ photo }) {
  const openPhoto = useLightbox();
  if (!photo?.src) return null;
  return (
    <button
      type="button"
      className={`pd-review-photo${photo.fit === "contain" ? " is-contain" : ""}`}
      onClick={() => openPhoto([photo], 0)}
      aria-label={`Enlarge customer photo: ${photo.alt}`}
    >
      <img src={photo.src} alt={photo.alt} loading="lazy" />
    </button>
  );
}
